import actionTypes from "./actionTypes";

//Action filter used in work item
export const changeWorklistFilter = filter => {
  return {
    type: actionTypes.CHANGE_WORKLIST_FILTER,
    payload: filter
  };
};

export const resetWorklistFilter = () => ({
  type: actionTypes.RESET_WORKLIST_FILTER
});

export const changeFilterInput = (field, value) => ({
  type: actionTypes.CHANGE_FILTER_INPUT,
  payload: { field, value }
});

export const resetWorkItems = () => ({
  type: actionTypes.RESET_WORK_ITEMS
});

export const fetchWorkItemAction = data => {
  return {
    type: actionTypes.FETCH_WORK_ITEMS,
    payload: data
  };
};

export const fetchWorkItemFailedAction = err => {
  return {
    type: actionTypes.FETCH_WORK_ITEMS_FAILED,
    payload: err
  };
};

export const fetchWorkItemSuccessAction = data => {
  return {
    type: actionTypes.FETCH_WORK_ITEMS_SUCCESS,
    payload: data
  };
};

export const selectWorkItemAction = id => {
  return {
    type: actionTypes.SELECT_WORKITEM,
    payload: id
  };
};

export const updateWorkItemAction = item => {
  return {
    type: actionTypes.UPDATE_WORKITEM,
    payload: item
  };
};

export const setCurrentWorkItemAction = item => {
  return {
    type: actionTypes.SET_CURRENT_WORKITEM,
    payload: item
  };
};
